import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadDefaultParameterConfig = async () => {
    try {
        const p_companyid = localStorage.getItem('companyid') || 0;

         return await callApi(API_ENDPOINTS.getDefaultParameterConfig, 'POST', { 'Content-Type': 'application/json' }, p_companyid);
        

    } catch (error) {
        console.error("Error saving parameter config:", error);
        throw error;
    }
};

export const loadDefaultParameterConfigById = async (payload) => {
    try {
        // const p_companyid = localStorage.getItem('companyid') || 0;

         return await callApi(API_ENDPOINTS.getDefaultParameterConfigById, 'POST', { 'Content-Type': 'application/json' }, payload);
        

    } catch (error) {
        console.error("Error saving parameter config:", error);
        throw error;
    }
};